<template>
    <div class="right-part-cases">
        <ul class="cases">
            <li v-if="typeof($attrs.score) == ''">
                <div class="trustbox-custom medium dark">
                    <div class="first-part">
                        <div class="trustpilot-logo">
                            <img src="@images/trustpilot/logo_black.png" alt="logo_white">
                        </div>
                    </div>

                    <div class="second-part">
                        <div class="score-image">
                            <div class="score-image_placeholder">
                                <img src="@images/trustpilot/45stars.png" alt="45stars">
                            </div>
                        </div>
                    </div>
                    <div class="third-part">
                        <div class="trustscore-text">
                            TrustScore
                        </div>
                        <div class="trustscore-num">
                            {{ $attrs.score }}
                        </div>
                        |
                        <div class="reviews-text">
                            {{ $t('f_trustpilot_reviews_text') }}
                        </div>
                        <div class="reviews-num">
                            {{ $attrs.reviews }}
                        </div>
                    </div>
                </div>
            </li>
            <li>
                <div class="point">
                    <div class="data">
                        <div class="image-placeholder">
                            <img src="@images/right_panel/people_200.png" alt="people">
                        </div>
                        <div class="number">
                            {{ $attrs.total_clients }}
                            <!-- = number_for_show(CounterComplaint.total_amount, @locale) -->
                        </div> 
                    </div>
                    <div class="description">
                        {{ $t('f_about_page_total_passenger_helped') }}
                    </div>
                </div>
            </li>
            <li>
                <div class="point">
                    <div class="data">
                        <div class="image-placeholder">
                            <img src="@images/right_panel/hand_with_coins_200.png" alt="hand_with_coins">
                        </div>
                        <div class="number">
                            {{ $attrs.average_saved }}
                            <!-- = number_for_show(CounterComplaint.total_amount, @locale) -->
                        </div> 
                    </div>
                    <div class="description">
                        {{ $t('f_about_page_average_saved') }}
                    </div>
                </div>
            </li>
            <li>
                <div class="point">
                    <div class="data">
                        <div v-if="$i18n.locale == 'dk'" class="image-placeholder">
                            <img src="@images/right_panel/money_200.png" alt="money">
                        </div>
                        <div v-if="$i18n.locale == 'no'" class="image-placeholder">
                            <img src="@images/right_panel/money_200.png" alt="money">
                        </div>
                        <div v-if="$i18n.locale == 'se'" class="image-placeholder">
                            <img src="@images/right_panel/money_200.png" alt="money">
                        </div>
                        <div v-if="$i18n.locale == 'pl'" class="image-placeholder">
                            <img src="@images/right_panel/money_200_eur.png" alt="money">
                        </div>
                        <div v-if="$i18n.locale == 'cz'" class="image-placeholder">
                            <img src="@images/right_panel/money_200_eur.png" alt="money">
                        </div>
                        <div v-if="$i18n.locale == 'fi'" class="image-placeholder">
                            <img src="@images/right_panel/money_200_eur.png" alt="money">
                        </div>
                        <div v-if="$i18n.locale == 'de'" class="image-placeholder">
                            <img src="@images/right_panel/money_200_eur.png" alt="money">
                        </div>
                        <div v-if="$i18n.locale == 'ca'" class="image-placeholder">
                            <img src="@images/right_panel/money_200_usd.png" alt="money">
                        </div>
                        <div v-if="$i18n.locale == 'en'" class="image-placeholder">
                            <img src="@images/right_panel/money_200_gbp.png" alt="money">
                        </div>

                        <div class="number">
                            {{ $attrs.total_compensation }}
                            <!-- = number_for_show(CounterComplaint.total_amount, @locale) -->
                        </div> 
                    </div>
                    <div class="description">
                        {{ $t('f_about_page_total_amount') }}
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

// <script>

export default {

  data() {
    return {
      trustpilotReady: false,
      checkingInterval: null,
    }
  },
  watch: {
    trustpilotReady: function() {
        clearInterval(this.checkingInterval)
    }
  },
  created() {
    let localThis = this 
    this.checkingInterval = setInterval(function(){
      if (window.Trustpilot) {
        localThis.trustpilotReady = true
      }
    }, 500) //or whatever interval you want to check 
  }
}

// </script>


<style lang="scss">
  .right-part-cases {
    height: 100%;
    // color: #323b48 !important;
    background-color: #f3f3f3;
    box-shadow: inset 13px 0px 63px -32px rgba(0, 0, 0, 0.85);

    .case-title {
      margin-top: 0;
      padding: 40px 0 0 40px;
      font-size: 30px;
    }

    .trustbox-custom.medium{
      width: 100%;
      height: 180px;
      display: flex;
      flex-direction: column;
      font-size: 1em;
      color: white;
      .first-part {
        height: 60px;
        align-items: flex-end;
        .trustpilot-logo {
          height: 60px;
          & img {
            height: 100%;
          }
        }
      }

      .second-part {
        .score-image {
          .score-image_placeholder {
            height: 40px;
            & img {
              height: 100%;
            }
          }
        }
      }

      .third-part {
        display: flex;
        flex-direction: row;
        margin-top: 10px;
        justify-content: flex-start;
        & .trustscore-text {

        }
        & .trustscore-num {
          font-weight: 600;
        }
        & .reviews-text {

        }
        & .reviews-num {
          font-weight: 600;
        }
        & div {
          margin-right: 5px;
        }
      }
    }

    .trustbox-custom.medium.dark {
      color: black;
    }

    .trustbox-custom.medium.light {
      color: white;
    }


    ul.cases {
      padding: 0;
      padding-top: 1px;
      margin-top: 0;
      list-style: none;

      > li {
        margin-bottom: 40px;
        padding: 0 40px 20px 40px;
        border-bottom: 1px solid #c1c1c1;

        & .point {
          display: flex;
          flex-direction: column;
          align-items: center;
          & .data {
              display: flex;
              flex-direction: column;
              align-items: center;
              & .image-placeholder {
                height: 100px;
                width: 100px;
                & img {
                  height: 100%;
                }
              }
              & .number {
                font-size: 1.2em;
                padding: 15px 0;
                font-weight: 600;
              }
          }
        }

        &:last-child {
          border-bottom: none;
        }

        > h3 {
          font-weight: 300;
        }

        > p {
          color: #636363;
        }

        .trustpilot-widget{
          padding-top: 20px;
          height: 150px;
          iframe{
            margin: auto;
          }
        }
      }
    }
  }
</style>
